import {
  UNLEASH_FEATURE_FLAGS_LOAD_FAILURE,
  UNLEASH_FEATURE_FLAGS_LOAD_SUCCESS,
  UNLEASH_FEATURE_FLAGS_LOAD,
  UNLEASH_FEATURE_FLAG_TOGGLE,
} from './types';

export function loadFeatureFlags(businessId) {
  return {
    type: UNLEASH_FEATURE_FLAGS_LOAD,
    payload: {
      businessId,
    },
  };
}

export function loadFeatureFlagsSuccess(flags) {
  return {
    type: UNLEASH_FEATURE_FLAGS_LOAD_SUCCESS,
    payload: {
      flags,
    },
  };
}

export function loadFeatureFlagsFailure(error) {
  return {
    type: UNLEASH_FEATURE_FLAGS_LOAD_FAILURE,
    error: true,
    payload: error,
  };
}

export function toggleFeatureFlag(id) {
  return {
    type: UNLEASH_FEATURE_FLAG_TOGGLE,
    payload: {
      id,
    },
  };
}
